import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import {
    StrategicAlly,
    StrategicAllyFilter,
} from '../../../../../shared/types/modules/strategicAlly';
import { DateTooltip } from '../../../../components/general/dateTooltip';
import { asyncGetStrategicAllys } from '../../../../../services/strategicAlly.service';

export const useStrategicAllyList = (filters?: StrategicAllyFilter) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<StrategicAlly[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<StrategicAllyFilter>({});

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<StrategicAlly>[] = [
        {
            field: 'code',
            headerName: 'Código',
            minWidth: 120,
            flex: 0.4,
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'email',
            headerName: 'E-mail',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'cellPhone',
            headerName: 'Celular',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'phone',
            headerName: 'Teléfono',
            minWidth: 150,
            flex: 0.6,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTooltip date={row.row.created_at} />,
        },
    ];

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetStrategicAllys(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
